// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Hi {{first_name}}, what do you need for {{restaurant}}?',
  title_no_name: 'Hi, what do you need for {{restaurant}}?',
  text: 'I can answer questions about {{restaurant}} and make changes for you. Nothing changes until you approve it.',
  suggestions: 'Suggestions',
  prompts: {
    reports: {
      top_dishes: 'What were the top 10 dishes last month?',
      sales_vs_last_month: 'How did sales compare to last month?',
    },
    menu: {
      raise_dish_price: 'Raise the price of {{dish}} by {{amount}}',
      dish_sold_out: 'Mark {{dish}} sold out',
      dishes_without_photo: 'Which dishes have no photo?',
    },
    hours: {
      holiday_hours: 'Change our opening hours for 24 December',
    },
    order_settings: {
      minimum_order: 'Raise the minimum order to {{amount}}',
    },
    marketing: {
      promo_code: 'Create a 10 % promo code for this weekend',
    },
    my_info: {
      phone_number: 'Update our phone number',
    },
  },
};
